import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CommonDataService } from '../../services/common-data.service';
import { GraphqlService } from '../../services/graphql.service';
import { LoginService } from '../../services/Login.service';
import { SessionService } from '../../services/Session.service';

@Component({
  selector: 'app-inline-glossary',
  templateUrl: './inline-glossary.component.html',
  styleUrls: ['./inline-glossary.component.css']
})
export class InlineGlossaryComponent implements OnInit {

  glossaryTermId:string="";
  glossaryTitle:string="";
  glossaryTermUsage:string="";
  glossaryBody:any="";
  glossaryData:any=[];
  glossarytopic:any;
  seeTopics:string="";
  noLinks: string = "";
  /*isBasicUser: boolean = false;*/
  event$;

  @Input() TermId:string="";
  @Output() myEvent = new EventEmitter<string>();
  isStarting:boolean;
  constructor(private commonDataService: CommonDataService, private graphQlService: GraphqlService, public loginService: LoginService, private session: SessionService,
    private domSanitizer: DomSanitizer, private route: Router, public dialog: MatDialog) { }

  ngOnInit(): void {
    //if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
    //  this.loginService.getSession().subscribe(data => {
    //    if (data.user.roles == "Basic") {
    //      this.isBasicUser = true;
    //    }
    //    this.session.assignSession(data);
    //  })
    //}
    //else {
    //  if (this.session.userInfo.user.roles == "Basic") {
    //    this.isBasicUser = true;
    //  }
    //}
    this.isStarting=false;
    this.getGlossaryData();
    
    this.event$
      = this.route.events
        .pipe(
          filter(event => event instanceof NavigationEnd)
    )
      .subscribe(() => { 
         this.closeOverlay(); 
       
      })
  }

  ngOnChanges(){
    if(this.isStarting){
      this.ngOnInit();
    }
  }

  contacts:any=[];
  distinctTopics:any=[];
  getGlossaryData(){
    this.glossaryTermId = this.commonDataService.glossaryTermId.getValue();

    // this.commonDataService.glossaryTermId.subscribe(glossaryID=>{
    // this.glossaryTermId=glossaryID;
      this.commonDataService.showLoader.next(true)
      this.glossarytopic = [];
        this.distinctTopics=[];
        this.contacts=[];
        this.glossaryData=[];
      if (this.glossaryTermId != "" && this.glossaryTermId != null) {
        forkJoin([
          this.graphQlService.getInlineGlossaryContent(this.glossaryTermId),
          this.graphQlService.getGlobalLabels()
        ]).subscribe(([glossaryData, glossaryLabels]) => {
          this.isStarting=true;
          var labels = glossaryLabels.content.data.labels;
    
          this.mapGlossaryContent(glossaryData?.hits?.hitsList);
          //this.delay(3000);
          this.glossaryTermUsage = labels.filter(x => x.key == "glossary_termUsage").map(y => y.value);
          this.noLinks = labels.filter(x => x.key == "noIncomingLink").map(y => y.value);
          this.seeTopics = labels.filter(x => x.key == "glossary_see").map(y => y.value);
        }, err => {
          console.log(err);
          this.commonDataService.showLoader.next(false);
        });
        }
        else{
          this.commonDataService.showLoader.next(false);
        }
  }

  formattedGlossaryTitle: any = "";
  mapGlossaryContent(data) {
    if (data) {
      data.forEach(res => {
        this.glossarytopic = [];
        this.distinctTopics=[];
        this.contacts=[];
        let source = res.source;
        this.glossaryTitle = source.title==null?"NA":source.title;
        let breadcrumbPath = source.levelThree == source.title ? "" : source.levelThree.startsWith(source.levelTwo) ? " ( " + source.levelThree?.split("-")[1] + " )" : " ( " + source.levelThree + " )";
        breadcrumbPath=" <span class='overlay-bread-crumb'>"+breadcrumbPath+"</span>";
        this.glossaryTitle=this.glossaryTitle!="NA"?this.glossaryTitle+breadcrumbPath:this.glossaryTitle;
        this.formattedGlossaryTitle = source.formattedGlossaryTitle != null ? source.formattedGlossaryTitle + breadcrumbPath : this.glossaryTitle;
        source.body=source.body.replace("xref","xref gasb-display-inline-block")
        this.glossaryBody = this.domSanitizer.bypassSecurityTrustHtml(source.body);
        if (source.usage != null) {
          source.usage.forEach(usage => {
            this.glossarytopic.push(usage)
          });
        }
        var count=0;
        // if(this.glossarytopic.length>0){
        //   this.glossarytopic.forEach(topicRes=>{
        //       if(count==0){
        //         let obj={
        //           topic:topicRes.topic,
        //           topicData:[topicRes]
        //         }
        //          this.distinctTopics.push(obj);
        //           count++;
        //       }
        //       else{
        //         var topics=this.distinctTopics.filter(x=>x.topic==topicRes.topic);
        //         if(topics.length>0){
        //           this.distinctTopics.filter(x=>x.topic==topicRes.topic)[0].topicData.push(topicRes);
        //         }
        //         else{
        //           let obj={
        //             topic:topicRes.topic,
        //             topicData:[topicRes]
        //           }
        //            this.distinctTopics.push(obj);
        //         }
        //         count++;
        //     }
        //   })
        // }
        // this.distinctTopics=this.distinctTopics.sort((a, b) => (a.topic < b.topic) ? -1 : 1);
        this.glossaryData = { name: this.glossaryTitle,formattedGlossaryTitle: this.formattedGlossaryTitle, body: this.glossaryBody,topic: this.glossarytopic, seetopic: this.distinctTopics ,type:source.glossaryType};
        this.contacts.push(this.glossaryData);
      })
      this.commonDataService.showLoader.next(false);
    }
  }

  onRightClick(event){
    let classname = event.target.classList;
    let termClassName = event.target.parentNode.className;
    if (termClassName == "term" || classname.contains("term")) {
      event.preventDefault();
    }
  }

  OpenLink(event) {
    const path : any = event.composedPath() as Array<any>;
    event.preventDefault();
    const xref = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className == "xref");
    const term = event.target.className.includes("term");
    const diamondLink=path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className.includes("xref") &&  p.className.includes("diamond_link"));
    if(xref)
    {
      let href=xref.getAttribute("href");
      if(href.includes("http")){
        window.open(href);
      }
      else {
        if (this.route.url.includes("GlossaryTermFinder")) {
          this.commonDataService.glossaryTermFromContentPageBackButton.next(this.glossaryTitle);
        }
        let urlParts = href.split("/");
        let urlLastPart = href.includes('#') ? href.split('#')[1] : urlParts[urlParts.length - 1];
        let url = "/" + urlParts[1] + "/" + urlParts[2] + "/" + urlLastPart;
        this.route.navigateByUrl(url);
        this.myEvent.emit();
      }
      // this.route.navigateByUrl("/1852827/1830712")
    }
    else if(term){
    let id = event.target.id;

    event.preventDefault();
    id=id=="" && term!=null && term !=undefined?event.target.parentNode.id:id;
    
    let obj=this.commonDataService.parentComponentDetails.getValue();
    obj.push({
      source:"inline-glossary",
      data:this.glossaryTermId,
      panelWidth:"rightOverLay_small"
    });
    this.commonDataService.glossaryTermId.next(id);
    this.getGlossaryData();
    this.commonDataService.parentComponentDetails.next(obj);
    }
    else if (diamondLink) {
      let href = diamondLink.getAttribute('href');
      let otherSourceUrlParts = href?.split("/");
      let publicationId = otherSourceUrlParts[1];
      let pageId = otherSourceUrlParts[2];
      let paraId = href?.includes('#') ? href?.split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
      window.open(location.origin + "/" + publicationId + "/" + pageId + "/" + paraId, '_blank').focus();
    }
    else if (path.find(p => p.tagName && p.tagName.toLowerCase() === 'a')) {
      if (this.route.url.includes("GlossaryTermFinder")) {
        this.commonDataService.glossaryTermFromContentPageBackButton.next(this.glossaryTitle);
      }
      let href=path.find(p => p.tagName && p.tagName.toLowerCase() === 'a').getAttribute("href");
      let urlParts = href.split("/");
      let urlLastPart = href.includes('#') ? href.split('#')[1] : urlParts[urlParts.length - 1];
      let url = "/" + urlParts[1] + "/" + urlParts[2] + "/" + urlLastPart;
      if (!this.route.url.includes("sourcetracingtool")) { this.route.navigateByUrl(url); }
      else {
        var baseUrl = window.location.origin;
        window.open(baseUrl + url)
      }
    }
  }

  closeOverlay() {
    this.myEvent.emit();
    // this.commonDataService.glossaryParentGuid.next([]);
  }
}
